import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import SubmodalityForm from '../components/forms/SubmodalityForm';
import '../styles/EmployeeMaster.css';
import SubmodalityTable from '../components/SubmodalityTable';

const SubmodalityModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/submodality/add';

  const handleAddClick = () => {
    navigate('/submodality/add');
  };

  const handleCloseModal = () => {
    navigate('/submodality');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Sub Modality Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Sub Modality
        </button>
      </div>

      <SubmodalityTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Sub Modality</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SubmodalityForm />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {/* <Button variant="primary">
            Save
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubmodalityModel;
